"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubMoyenneTransactionCorporationTrads = void 0;
exports.ESubMoyenneTransactionCorporationTrads = {
    between_100k_300k: "Entre 100k et 300k",
    between_15k_50k: "Entre 15k et 50k",
    between_300k_500k: "Entre 300k et 500k",
    between_500k_1000k: "Entre 500k et 1000k",
    between_50k_100k: "Entre 50k et 100k",
    greater_1000k: "Plus de 1000k",
    less_15k: "Moins de 15k",
};
